export const useEnv = () => {
    const appEnv = process.env.GATSBY_APP_ENV
    return {
        isDev: appEnv === 'development',
        isStaging: appEnv === 'staging',
        isProd: appEnv === 'production'
    }
}
